import { render, staticRenderFns } from "./withoutCard.vue?vue&type=template&id=2c585aaf&scoped=true&"
import script from "./withoutCard.vue?vue&type=script&lang=js&"
export * from "./withoutCard.vue?vue&type=script&lang=js&"
import style0 from "./withoutCard.vue?vue&type=style&index=0&id=2c585aaf&lang=scss&scoped=true&"
import style1 from "./withoutCard.vue?vue&type=style&index=1&id=2c585aaf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c585aaf",
  null
  
)

export default component.exports